<ng-container *ngIf="expiringVouchers$ | async as expiringVouchers">
  <div *ngIf="expiringVouchers.length > 0">
    <fcom-notification
      [theme]="NotificationTheme.INFO"
      [layout]="NotificationLayout.BLOCK"
      [isClosable]="true"
      [i18n]="{ closeAriaLabel: 'plus.profile.closeNotification' }"
      (closeClick)="onCloseNotification()"
    >
      <a
        class="nordic-blue-900-text no-underline font-body-1"
        [finLink]="oneUpgradeUrl$ | async"
        [finElemTracker]="TRACKING_ELEMENT_NAME"
        [finElemContext]="GTM_TRACKING_CONTEXT"
        [finElemType]="ElementTypes.BANNER"
      >
        <span>
          <ng-container *ngIf="expiringVouchers.length > 1">{{
            'plus.expiringVoucherNotification.multiple' | finLocalization
          }}</ng-container>
          <ng-container *ngIf="expiringVouchers.length === 1" [ngSwitch]="expiringVouchers[0].productName">
            <ng-container *ngSwitchCase="VoucherProductName.EUROPE_UPGRADE">{{
              'plus.expiringVoucherNotification.europeUpgrade'
                | finLocalization: { date: expiringVouchers[0].expirationDate | finDateFormat: 'DATE' }
            }}</ng-container>
            <ng-container *ngSwitchCase="VoucherProductName.LONG_HAUL_UPGRADE">{{
              'plus.expiringVoucherNotification.longHaulUpgrade'
                | finLocalization: { date: expiringVouchers[0].expirationDate | finDateFormat: 'DATE' }
            }}</ng-container>
          </ng-container>
        </span>
        <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.ARROW_RIGHT"></fcom-icon>
      </a>
    </fcom-notification>
  </div>
</ng-container>
